interface ISiteElementCheckItem {
    addValue(value: ISiteFilterItemValue): void;
    removeValue(value: ISiteFilterItemValue): void;
    containsValue(value: ISiteFilterItemValue): boolean;
}

class SiteElementCheckItem
    extends QueryElement<HTMLElement> {

    private readonly _filter: ISiteElementCheckItem;
    private readonly _value: ISiteFilterItemValue;
    
    constructor(
        filter: ISiteElementCheckItem, 
        value: ISiteFilterItemValue) {
        
        super(document.createElement("A"));

        this._filter = filter;
        this._value = value;
        
        this.addClass("element-filter-checkitem");
        
        let title = QueryElement.QueryElement("SPAN")
            .addClass("title")
            .setText(value.name);

        this.append(title);
        
        if (value.count != null) {
            let count = QueryElement.QueryElement("SPAN")
                .addClass("count")
        
            count.setText(value.count.toString());
            
            this.append(count);
        }
        
        if (filter.containsValue(value))
            this.makeActive();
        

        this.on("click", e => {
            this.click();
        })
    }

    click() {
        if (this.isActive()) {
            this._filter.removeValue(this._value);
            this.makeInactive();
        } else {
            this._filter.addValue(this._value);
            this.makeActive();
        }
    }
    makeActive() {
        this.addClass("active");
    }
    makeInactive() {
        this.removeClass("active");
    }
    isActive() {
        return this.containsClass("active");
    }
}